import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconPencil, IconTrash } from '@tabler/icons-react';
import * as React from 'react';
import { TOOLTIPS } from '../../../resource/tooltipTexts';

export const EditDeleteButtons= ({ handleEdit, handleDelete, withoutToolTip, readonly }: {
    handleEdit?: () => void;
    handleDelete?: () => void;
    withoutToolTip?: boolean;
    readonly?: boolean;
}) => {
    if (withoutToolTip) {
        return (
            <Group justify="flex-end" gap={6} style={{display: 'inline-flex', alignItems: "center"}}>
                {handleEdit && (
                    <ActionIcon
                        size={'sm'}
                        onClick={handleEdit}
                        variant={"transparent"}
                        color={"var(--mantine-color-base-button)"}
                        disabled={readonly}
                    >
                        <IconPencil />
                    </ActionIcon>
                )}
                {handleDelete && (
                    <ActionIcon
                        size={'sm'}
                        onClick={handleDelete}
                        variant={"transparent"}
                        color={"var(--mantine-color-base-button)"}
                        disabled={readonly}
                    >
                        <IconTrash />
                    </ActionIcon>
                )}
            </Group>
        );
    }

    return (
        <Group justify="flex-end" gap={6} style={{display: 'inline-flex', alignItems: "center"}}>
            {handleEdit && (
                <Tooltip label={TOOLTIPS.EDIT}>
                    <ActionIcon
                        size={'sm'}
                        onClick={handleEdit}
                        variant={"transparent"}
                        color={"var(--mantine-color-base-button)"}
                        disabled={readonly}
                    >
                        <IconPencil />
                    </ActionIcon>
                </Tooltip>
            )}
            {handleDelete && (
                <Tooltip label={TOOLTIPS.DELETE}>
                    <ActionIcon
                        size={'sm'}
                        onClick={handleDelete}
                        variant={"transparent"}
                        color={"var(--mantine-color-base-button)"}
                        disabled={readonly}
                    >
                        <IconTrash />
                    </ActionIcon>
                </Tooltip>
            )}
        </Group>
    );
};


